import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setCartList, setloading, seterror, resetCartList,clearPaymentFlag 
} from "../reducers/cartlistReducer";

const cartList = (token: any) => async (dispatch: Dispatch) => {    
    dispatch(setloading(true));
    try {
        const result = await api.get(
            `orders/cart/view-cart/`,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Token ${token}`
                },
            }
        )

        dispatch(setloading(false));
        
        if (result.data?.status === 200) {
            dispatch(setCartList(result.data.data));
            
            return result.data.data; 
        } else {
            dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
        }
    }
    catch (error: any) {
        dispatch(setloading(false));
        dispatch(seterror(error.response?.data?.message ?? "Error occurred"));
    }
}

export { cartList, resetCartList, setloading ,clearPaymentFlag }
